// Static option lists sourced from the live brandcompliance form HTML (2026-06-16).
//
// STATIC_BUSINESS_AREAS is always used: business areas are not DB-backed (there is
// no BrandComplianceConfigDto.BusinessAreas), so this list is the sole source for
// the "Verizon business area" dropdown, and its ids are display names by design
// (the backend BusinessArea field is a plain string, not a Guid-backed lookup).
//
// STATIC_ASSET_TYPES is a fallback only, used if the /brand-compliance/config
// request fails or returns no assetTypes. Its names are confirmed to match the
// core.brand_compliance_asset_types seed data.
//
// Agencies and functional areas have no static fallback: both are DB-backed,
// GUID-keyed lookups (core.brand_compliance_agencies, FunctionalAreas), and a
// name-as-id placeholder list can't produce a valid GUID for either — see
// BrandComplianceForm.tsx, which now sources them from
// useGetBrandComplianceConfigQuery() with no local fallback.

export interface BrandComplianceOption {
  id: string;
  name: string;
}

// Seeded GUID of the "Other" agency row (core.brand_compliance_agencies, added by
// the AddOtherBrandComplianceAgency migration) — selecting it reveals the free-text
// "Other creative agency" input.
export const OTHER_AGENCY_ID = "00000000-0000-0000-0000-000000000301";

export const STATIC_BUSINESS_AREAS: BrandComplianceOption[] = [
  { id: "Frontier", name: "Frontier" },
  { id: "Verizon Consumer Group", name: "Verizon Consumer Group" },
  { id: "Verizon Business Group", name: "Verizon Business Group" },
  { id: "Verizon Corporate/Internal", name: "Verizon Corporate/Internal" },
  { id: "Verizon Connect", name: "Verizon Connect" },
];

// Sourced from the live brandcompliance form's Asset Type select (2026-07-07).
// The "Select" placeholder option ("No Asset Type Specified") is intentionally omitted.
// Mirrors the 31 names seeded into core.brand_compliance_asset_types.
export const STATIC_ASSET_TYPES: string[] = [
  "Banners/OLA",
  "Broadcast segment",
  "Catalog - Brochure",
  "Circulars - Flyers",
  "Digital signage",
  "Direct mail",
  "Ecard/Invitation",
  "Email",
  "Event materials",
  "Hospitality materials",
  "Illustration",
  "Image/photo",
  "In-store Digital",
  "In-store Merch Non-digital",
  "Intranet",
  "Mobile Apps",
  "OOH",
  "OOH Digital",
  "Other",
  "Presentation",
  "Print Ad",
  "Product Guides",
  "Promo Merchandise/Apparel",
  "Push notification",
  "Reports/Whitepaper",
  "Social Media post",
  "Storyboard",
  "Tradeshow",
  "TV spot",
  "Video/Demos",
  "Website",
];
